import React, { useState, useEffect } from "react";
import UIButton from "components/UI/Button/Button";
import * as ConfigTypes from 'config/ConfigTypes';
import "./AcceptForm.scss";

const AcceptForm = ({ formatMessage, onInsitution, onUser, setInitData, updateAuthObjects }) => {
    let data = ConfigTypes.ACCEPT_ITEMS;
    useEffect(() => {
        setInitData({ authForm: ConfigTypes.ACCEPT, showAuth: true });
    }, []);

    const handleInstClick = () => {
        updateAuthObjects({ registerAs: ConfigTypes.REGISTER_INST });
        onInsitution();
    }

    const handleUserClick = () => {
        updateAuthObjects({ registerAs: ConfigTypes.REGISTER_USER });
        onUser();
    }
    return (
        <div className="AcceptForm">
            <h1 className="acceptform-heading">
                {formatMessage({ id: "data.auth.acceptform" })}
            </h1>
            <>
                <>
                    {data.map(item => (
                        <p className="loginform-logintext" key={`acceptform_${item.name}`}>
                            {formatMessage({ id: item.intl })}
                        </p>
                    ))}
                </>
                <div className="acceptform-btn-actions">
                    <UIButton textOnly onClick={handleUserClick} className="acceptform-button">
                        {formatMessage({ id: "data.auth.btnfreelancer" })}
                    </UIButton>
                    <UIButton textOnly onClick={handleInstClick} className="acceptform-button">
                        {formatMessage({ id: "data.auth.btninstitution" })}
                    </UIButton>
                </div>
            </>
        </div>
    )
}

export default AcceptForm;